import React from "react";
import { Grid, Typography } from "@mui/material";
import { QrScannerTribunal } from "../components/QrScanner";
import { InvitadoLayout } from "layouts/invitado/invitadoLayout";

export const FormScanQR = () => {
  return (
    <InvitadoLayout>
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
          <Typography variant="h5" gutterBottom>
            Escáner de Códigos QR
          </Typography>
          <QrScannerTribunal />
          <Typography variant="body1" gutterBottom>
            Apunte la cámara hacia un código QR para escanearlo.
          </Typography>
        </Grid>
      </Grid>
    </InvitadoLayout>
  );
};
